import { apiClient } from './client';

/** Ключевые показатели портфеля менеджера (см. DashboardController в Laravel). */
export interface DashboardKpis {
  clients: number;
  newThisMonth: number;
  newPrevMonth: number;
  expiringSoon: number;
  expired: number;
  balanceTotal: number;
  ueIssuedThisMonth: number;
  ueSpentThisMonth: number;
  testsConnected: number;
  openTickets: number;
}

/** Точка графика портфеля: сколько кабинетов было на конец месяца. */
export interface GrowthPoint {
  /** YYYY-MM. */
  month: string;
  added: number;
  clients: number;
}

export interface UeFlowPoint {
  month: string;
  issued: number;
  spent: number;
}

export type AttentionSeverity = 'critical' | 'warning' | 'neutral';
export type AttentionKind = 'expired' | 'expiring' | 'no-tests';

export interface AttentionItem {
  clientId: number;
  company: string | null;
  issue: string;
  actionLabel: string;
  severity: AttentionSeverity;
  kind: AttentionKind;
}

export interface ActivityItem {
  id: number;
  clientId: number;
  company: string | null;
  description: string | null;
  status: string | null;
  at: string;
}

export interface StatusBreakdown {
  active: number;
  demo: number;
  disabled: number;
}

export interface TopTestItem {
  name: string | null;
  clientsCount: number;
}

export interface DashboardData {
  managerName: string | null;
  /** all — видны все кабинеты, portfolio — только курируемые. */
  scope: 'all' | 'portfolio';
  kpis: DashboardKpis;
  statusBreakdown: StatusBreakdown;
  growth: GrowthPoint[];
  ueFlow: UeFlowPoint[];
  topTests: TopTestItem[];
  attention: AttentionItem[];
  recentActivity: ActivityItem[];
}

export async function fetchDashboard(): Promise<DashboardData> {
  const { data } = await apiClient.get<DashboardData>('/dashboard');
  return data;
}

export interface DashboardNotifications {
  items: AttentionItem[];
  total: number;
}

/** Лёгкая часть сводки для колокольчика в шапке — без графиков и KPI. */
export async function fetchNotifications(): Promise<DashboardNotifications> {
  const { data } = await apiClient.get<DashboardNotifications>('/dashboard/notifications');
  return data;
}
